import { Navigate, useLocation } from "react-router-dom";
import useLanguage from "../i18n/useLanguage";

export default function LegacyAiRedirect() {
  const { href } = useLanguage();
  const { search, hash } = useLocation();
  return <Navigate replace to={`${href("/ai-photo-video")}${search}${hash}`} />;
}
